// hooks/useResultados.js
import { useState, useEffect } from 'react';
import axios from 'axios';

// URL base de la API
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// Hook personalizado para manejar los resultados del usuario
const useResultados = () => {
  // Estado para almacenar el resumen de resultados
  const [resumen, setResumen] = useState({
    total_correctas: 0,
    total_incorrectas: 0,
    total_preguntas: 0,
    resumen: ''
  });
  // Estado para manejar la carga de datos
  const [cargando, setCargando] = useState(true);
  // Estado para manejar errores
  const [error, setError] = useState('');

  // Efecto para cargar el resumen al montar el componente
  useEffect(() => {
    cargarResumen();
  }, []);

  // Función para cargar el resumen de resultados desde la API
  const cargarResumen = async () => {
    try {
      // Obtener el token de autenticación del almacenamiento local
      const token = localStorage.getItem('token');
      // Realizar la petición GET a la API con el token en el header
      const response = await axios.get(`${API_BASE_URL}/api/resultados/resumen`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      // Actualizar el estado con los datos recibidos
      setResumen(response.data);
      // Marcar la carga como completada
      setCargando(false);
    } catch (error) {
      // Manejar errores: loggear en consola y actualizar el estado de error
      console.error('Error al cargar resumen:', error);
      setError('Error al cargar el resumen. Por favor, intenta de nuevo más tarde.');
      // Marcar la carga como completada (aunque haya fallado)
      setCargando(false);
    }
  };

  // Calcular el porcentaje de aciertos
  const porcentajeAciertos = (resumen.total_correctas / resumen.total_preguntas) * 100;
  // Determinar si el usuario ha aprobado (50% o más de aciertos)
  const aprobado = porcentajeAciertos >= 50;

  // Retornar los estados y valores calculados
  return { resumen, cargando, error, aprobado };
};

export default useResultados;